
import { defineComponent, ref, toRef } from "vue";
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";

export default defineComponent({
    name: "CigoTipProgress",
    components: {
        CigoIconFont
    },
    props: {
        layerData: {
            type: Object,
            default: {}
        }
    },
    setup(props, ctx) {
        let percent = toRef(props.layerData, "percent");
        let tips = toRef(props.layerData, "tips");
        return { percent, tips };
    }
});
